import { useIntl } from 'react-intl';

import { ResetIcon } from '@dynatrace/strato-icons';

import { allowWhenKeyIsEnter, areAllDomainsUnchanged } from './utils.js';
import { KeyboardControls } from '../../../core/components/interactions-overlay/constants.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { useA11yToolbarTabIndex } from '../../../core/hooks/useA11yToolbarTabIndex.js';
import { ZOOM_CHANGE_TYPE } from '../../../core/types/zoom.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { XYCHART_MESSAGES } from '../../messages/messages.js';
import { useResetInteractions } from '../overlay/hooks/useResetInteractions.js';

export const ResetButton = () => {
  const tabIndex = useA11yToolbarTabIndex(ZOOM_CHANGE_TYPE.Reset);
  const { axesMetadata, axes } = useXYChartData();
  const axisIdToScales = useXYChartScales();
  const intl = useIntl();
  const action = useResetInteractions();

  const resetDisabled =
    axesMetadata.isZoomEnabled && areAllDomainsUnchanged(axes, axisIdToScales);

  return (
    <ChartToolbarRenderer.Control
      prefixIcon={<ResetIcon />}
      tooltipText={intl.formatMessage(XYCHART_MESSAGES.resetMode)}
      tooltipKeyShortcut={KeyboardControls.KEYBOARD_RESET_SHORTCUT_ALTERNATIVE}
      onClick={action}
      onKeyDown={allowWhenKeyIsEnter(action)}
      tabIndex={tabIndex}
      disabled={resetDisabled}
      placement="toolbar"
      showWhenCollapsed={!resetDisabled}
      data-dt-name="ToolbarReset"
    />
  );
};

ResetButton['displayName'] = 'ResetButton';
